import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetPrestacionCUMEByID from "services/record/PrestacionCUME/useGetPrestacionCUMEByID";
import useGetInfoPrestacionCUME from "services/record/PrestacionCUME/useGetInfoPrestacionCUME";
import useGetPrestacionCUMEByUser from "services/record/PrestacionCUME/useGetPrestacionCUMEByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import PrestacionCUME from "./PrestacionCUME";

const GridPrestacionCUME = ({ expedienteId = null, origen = null }) => {

    const {
        getPrestacionCUMEByID,
        loadingGetPrestacionCUMEByID,
        statusGetPrestacionCUMEByID
    } = useGetPrestacionCUMEByID();

    const {
        getInfoPrestacionCUME,
        loadingGetInfoPrestacionCUME,
        statusGetInfoPrestacionCUME
    } = useGetInfoPrestacionCUME();

    const {
        dataGetPrestacionCUMEByUser,
        getPrestacionCUMEByUser,
        loadingGetPrestacionCUMEByUser,
        statusGetPrestacionCUMEByUser
    } = useGetPrestacionCUMEByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Prestación económica por cuidado de menores afectados por cáncer u otra enfermedad grave";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getPrestacionCUMEByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetPrestacionCUMEByID?.status) {
            setCurrentHttp({
                status: statusGetPrestacionCUMEByID.status,
                statusText: statusGetPrestacionCUMEByID.statusText
            });
        } else if (statusGetInfoPrestacionCUME?.status) {
            setCurrentHttp({
                status: statusGetInfoPrestacionCUME.status,
                statusText: statusGetInfoPrestacionCUME.statusText
            });
        } else if (statusGetPrestacionCUMEByUser?.status) {
            setCurrentHttp({
                status: statusGetPrestacionCUMEByUser.status,
                statusText: statusGetPrestacionCUMEByUser.statusText
            });
        }
    }, [
        statusGetPrestacionCUMEByID,
        statusGetInfoPrestacionCUME,
        statusGetPrestacionCUMEByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getPrestacionCUMEByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoPrestacionCUME(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetPrestacionCUMEByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 1 || item.EstadoFormulario === 3);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetPrestacionCUMEByUser]);

    const isLoading = () => {
        return (
            loadingGetPrestacionCUMEByID ||
            loadingGetInfoPrestacionCUME ||
            (loadingGetPrestacionCUMEByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetPrestacionCUMEByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <PrestacionCUME
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getPrestacionCUMEByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridPrestacionCUME;

